import React from 'react';
import buttonPropTypes from './ButtonProptypes';
import PrimaryButton from './PrimaryButton';

const PlainButton = ({ children, customClass = '', ...rest }) => {
  const buttonStyles = `bg-white border-white !text-black shadow-[0px_1px_10px_0px_rgba(0,0,0,0.25)] ${customClass}`;

  return (
    <PrimaryButton customClass={buttonStyles} {...rest}>
      {children}
    </PrimaryButton>
  );
};

PlainButton.propTypes = buttonPropTypes;

export default PlainButton;
